import { postJson } from "../methods";
function passwordReset(options) {
  return postJson({
    url: "api/user/password/reset",
    payload: options
  });
}
export {
  passwordReset as default
};
